import type { Product } from 'product/types'

export function getProductLinkLabel(product: Product, selectedColorId: string) {
	return `${product.name} - ${product.id} - (${selectedColorId})`
}
